<template>
  <div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top:20px;">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="stuName" placeholder="请输入证书类型名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getPermissionMenuList()">搜索</el-button>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>、
          <!-- <el-button type="primary" icon="el-icon-delete" @click="DeleteAllDialogVisible = true">删除</el-button> -->
        </el-form-item>
      </el-form>
    </header>

    <el-table :data="list">
      <el-table-column label="序号" type="index"></el-table-column>
      <el-table-column prop="menuName" label="菜单名称"></el-table-column>
            <el-table-column prop="menuKey" label="菜单标识"></el-table-column>
      <el-table-column prop="menuType" label="菜单类型">
            <template slot-scope="scope">
          <span v-if="scope.row.menuType==1">中物联官网（www.clppx.org.cn）</span>
          <span v-if="scope.row.menuType==2">中物联资源平台(resource.clpp.org.cn)</span>
          <span v-if="scope.row.menuType==3">中物联认证平台(bm.clpp.org.cn)</span>
        </template>
      </el-table-column>
            <el-table-column prop="menuLevel" label="菜单层级">
          <template slot-scope="scope">
          <span v-if="scope.row.menuLevel==1">第一层级</span>
          <span v-if="scope.row.menuLevel==2">第二层级</span>
        </template>
            </el-table-column>
      <el-table-column prop="parentMenuName" label="父级菜单">
        <template slot-scope="scope">
          <span v-if="!scope.row.parentMenuName">无</span>
          <span v-else>{{scope.row.parentMenuName}}</span>

        </template>
      </el-table-column>
       <el-table-column prop="sortOrder" label="排序"></el-table-column>
      <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
      <!-- <el-table-column prop label="证书类型">
        <template slot-scope="scope">
          <span v-if="scope.row.isCJ">初级</span>
          <span v-if="scope.row.isZJ">中级</span>
          <span v-if="scope.row.isGJ">高级</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

                <div class="permission-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
            </div>

    <el-dialog title="菜单管理" :modal="false" :visible.sync="dialogFormVisible" width="800px">
      <el-form :inline="true" :model="from" class="demo-form-inline" label-width="200px">
        <el-form-item label="菜单名称">
          <el-input v-model="from.menuName"></el-input>
        </el-form-item>
           <el-form-item label="菜单类型">
            <el-select  v-model="from.menuType"
                        placeholder="请选择对应平台"
                        clearable>
              <el-option label="中物联官网（www.clppx.org.cn）"
                        :value="1"></el-option>
              <el-option label="中物联资源平台(resource.clpp.org.cn)"
                        :value="2"></el-option>
              <el-option label="中物联认证平台(bm.clpp.org.cn)"
                        :value="3"></el-option>
            </el-select>
        </el-form-item>
             <el-form-item label="菜单标识">
          <el-input v-model="from.menuKey"></el-input>
        </el-form-item>
             <el-form-item label="菜单层级">
                <el-select  v-model="from.menuLevel"
                        placeholder="请选择对应层级"
                        clearable>
              <el-option label="第一层级"
                        :value="1"></el-option>
              <el-option label="第二层级"
                        :value="2"></el-option>
            </el-select>
        </el-form-item>
             <el-form-item label="父级菜单">
              <el-select 
                 v-model="from.parentMenuId"
                 placeholder="请选择父级菜单">
        <el-option label="---"
                   value="0"></el-option>
        <el-option v-for="(item,index) in parentMenuList"
                   :key="index"
                   :label="item.name"
                   :value="item.id"></el-option>
      </el-select>
        </el-form-item>
             <el-form-item label="菜单排序">
          <el-input v-model="from.sortOrder"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelInfo">取 消</el-button>
        <el-button type="primary" @click="savePermissionMenuInfo()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      checkList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      stuName: "",
      schoolName: "",
      idCard: "",
      certificateNum: "",
      examinationTypeId: "",
      examinationGradeId: "",
      list: [],
      from: {
        id:"",
        dateCreated:"",
        menuName:"",
        menuType:1,
        menuKey:"",
        menuLevel:2,
        parentMenuId:"",
        parentMenuName:"",
        sortOrder:1
      },
      parentMenuList:[],
      files: [],
      urlAliyunOSS: "/api/design/osssign/getsign",
      //编辑信息
      dialogFormVisible: false,
      //导入
      ImportDialogVisible: false,
      uploadUrl: "/api/XOrg/CertificateManager/uploadExcel",
      fileList: [], //导入文件
      errorList: [], //错误信息
      certTypeList: [],
      certGradeList: [],
      certTypeId: "",
      searchCertTypeList: [],
      searCertGradeList: [],
      // 批量删除
      DeleteAllDialogVisible: false,
      deleteStartTime: "",
      deleteEndTime: "",
      isCJ:1,
      isZJ:1,
      isGJ:1,
    };
  },
  components: {
    imageUpload,
  },
  created() {
    this.getPermissionMenuList();
    this.getParentMenuList();
    // this.getCertificateType();
    // this.getSearchCertificateType();
  },
  methods: {


      onPageChangeHandler(page) {
        this.pageIndex=page;
            this.getPermissionMenuList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getPermissionMenuList();
        },
    handleCheckedCitiesChange(val){
      debugger;
    },
    deleteAll() {
      var that = this;
      this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertificateManager/deleteCertificateAll", {
            startTime: this.deleteStartTime,
            endTime: this.deleteEndTime,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.DeleteAllDialogVisible = false;
              that.getStudentResultInfo();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    cancelDeleteAll() {
      this.DeleteAllDialogVisible = false;
      this.deleteStartTime = "";
      this.deleteEndTime = "";
    },
    getSearchCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateType")
        .then(function (rst) {
          if (rst.code > 0) {
            that.searchCertTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getSearchCertificateGrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.examinationTypeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.searCertGradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateType")
        .then(function (rst) {
          if (rst.code > 0) {
            that.certTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    typeChnage() {
      // this.getCertificateGrade();
      this.from.examinationGradeId = "";
    },
    getCertificateGrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.from.examinationTypeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.certGradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    cancelInfo() {
      this.from.name="";
      this.dialogFormVisible = false;
    },
    onSuccess(res) {
      if (res.code < 0) {
        if (res.code === -5) {
          this.errorList = res.list;
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        this.ImportDialogVisible = false;
        this.$message.success("导入成功");
        this.fileList = [];
        this.getStudentResultInfo();
      }
    },
    //清除数据
    cancel() {
      this.ImportDialogVisible = false;
      this.fileList = [];
    },
    addInfo() {
      this.dialogFormVisible = true;
      this.from.sortOrder=parseInt(this.from.sortOrder)+1;
      this.from.id="";
    },
    //编辑
    savePermissionMenuInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/PermissionMenu/savePermissionMenuInfo", {
          id: this.from.id,
          menuName: this.from.menuName,
          menuKey:this.from.menuKey,
          menuType:this.from.menuType,
          parentMenuId:this.from.parentMenuId,
          sortOrder:this.from.sortOrder,
          menuLevel:this.from.menuLevel
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.cancelInfo();
            that.getPermissionMenuList();
            that.getParentMenuList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //弹出框赋值
    handleEdit(row) {
      this.from.id = row.id;
      this.from.menuName = row.menuName;
      this.from.menuKey = row.menuKey;
      this.from.menuType=row.menuType;
      this.from.parentMenuId=row.parentMenuId;
      this.from.parentMenuName=row.parentMenuName;
      this.from.sortOrder=row.sortOrder;
      this.dialogFormVisible = true;
    },
    //删除
    deleteInfo(id) {
      var that = this;
      this.$confirm("此操作将删除菜单数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/PermissionMenu/deletePermissionMenu", {
            id: id,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.getPermissionMenuList();
              that.getParentMenuList();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    //获取列表
    getPermissionMenuList() {
      var that = this;
      this.$http
        .post("/api/XOrg/PermissionMenu/getPermissionMenuList",{page:that.pageIndex,pageSize:that.pageSize})
        .then(function (rst) {
          if (rst.code > 0) {
            that.list = rst.list;
          that.total = rst.pagination.totalCount;
          that.pageSize = rst.pagination.pageSize;
          that.pageIndex = rst.pagination.pageIndex;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
        //获取列表
    getParentMenuList() {
      var that = this;
      this.$http
        .post("/api/XOrg/PermissionMenu/getParentMenuList",{menuType:1})
        .then(function (rst) {
          if (rst.code > 0) {
            that.parentMenuList=rst.parentMenuList;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  .demo-form-inline {
    .el-input__inner {
      width: 200px;
    }
    .img_upload {
      width: 500px;
    }
  }

      .permission-page-con {
        padding: 20px 0;
        text-align: center;
    }
}
</style>